import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output, ViewChild
} from "@angular/core";
import {AccountModel} from "../../models/account.model";
import {AccountsQueryModel} from "../../models/accounts-query.model";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import * as _ from "lodash";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AccountsComponentStore} from "../../state/accounts-component.store";
import {Subscription} from "rxjs";

interface DemandAccountMultiSelectListModel {
  billingAccountIds: any;
  selectedIds: string[];
  branchIds: string[];
  depotIds: string[];
  excludeIds: string[];
  ngPlaceholder: any;
}

require('./demand-accounts-multi-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-demand-accounts-multi-select-list',
  templateUrl: './demand-accounts-multi-select-list.html',
  providers: [AccountsComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandAccountsMultiSelectListComponent implements OnInit, OnDestroy {

  @Output() onClose = new EventEmitter<any>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public selectedAccountIds: string[];
  public queryString: string = '';
  public selectedKeys: any;
  public excludedMap: any;
  public loadLimit: number = 20;
  public accounts: AccountModel[];
  public ngPlaceholder: string;
  public accountsSubscription: Subscription;
  public cursor: string;
  public isLoading: boolean;

  constructor(@Inject(PANEL_DATA) public data: DemandAccountMultiSelectListModel, @Inject(AccountsComponentStore) private accountsStore: AccountsComponentStore,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.selectedAccountIds = this.data.selectedIds;
    this.ngPlaceholder = this.data.ngPlaceholder;

    this.setExcludedIdsMap(this.data.excludeIds);

    this.setSelectedIdsMap();

    this._getAccounts();

    this.accountsSubscription = this.accountsStore.vm$.subscribe((vm) => {
      this.cursor = vm.cursor;
      this.isLoading = vm.loading;
      this.accounts = vm.accounts;
      this.cdkVirtualScrollViewport?.checkViewportSize();
      this.cdr.detectChanges();
    })
  }

  ngOnDestroy() {
    this.accountsStore.onResetAccounts();
    this.accountsSubscription.unsubscribe();
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 150 && this.cursor && !this.isLoading) {
      this._getAccounts();
    }
  }

  onToggle(accountId, isSelected) {
    this.selectedAccountIds = !isSelected ? _.concat(this.selectedAccountIds || [], [accountId]) :
      _.filter(this.selectedAccountIds, (id) => {
        return id !== accountId;
      });

    this.setSelectedIdsMap();
  }

  onSubmit() {
    this.onClose.emit({accountIds: this.selectedAccountIds})
  }

  onReset() {
    this.onClose.emit({accountIds: []})
  }

  onCancel() {
    this.onClose.emit({accountIds: this.selectedAccountIds})
  }

  onQueryChange(query) {
    this.queryString = query;
    this._resetStore();
    this._getAccounts();
  }

  onToggleSelectAll() {
    if (this.accounts?.length === this.selectedAccountIds?.length) {
      this.selectedAccountIds = []
      this.setSelectedIdsMap();
    } else {
      this.selectedAccountIds = this.accounts.map((a) => a.id);
      this.setSelectedIdsMap();
    }
  }

  private setExcludedIdsMap(excludeIds) {
    this.excludedMap = {};
    _.forEach(excludeIds, (id) => {
      this.excludedMap[id] = true;
    })
  }

  private setSelectedIdsMap() {
    this.selectedKeys = {};
    _.forEach(this.selectedAccountIds, (id) => {
      this.selectedKeys[id] = true;
    })
  }

  private _resetStore() {
    this.accountsStore.resetAccounts();
  }

  private _getAccounts() {
    this.accountsStore.getAccounts(this._getQueryPayload());
  }

  private _getQueryPayload(): AccountsQueryModel {
    const params: AccountsQueryModel = {
      limit: this.loadLimit,
      billingAccountIds: this.data.billingAccountIds,
      query: this.queryString,
      isDemand: true,
      branchIds: this.data.branchIds,
      depotIds: this.data.depotIds,
      sort: 'name,asc'
    };

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

}
